/**
 *
 * InputMask
 *
 */

import { FormControl, FormErrorMessage, FormLabel, Input, InputProps, Text } from '@chakra-ui/react';
import ReactInputMask from 'react-input-mask';

interface InputMaskProps extends InputProps {
	label?: string;
	errorMessage?: string;
	required?: boolean;
	disabled?: boolean;
	mask?: string;
}

const InputMask = ({ label, errorMessage, required, disabled, mask, ...rest }: InputMaskProps) => {
	return (
		<>
			<FormControl isInvalid={!!errorMessage}>
				{label && (
					<FormLabel>
						{label}{' '}
						{required && (
							<Text variant="required" as="span">
								*
							</Text>
						)}
					</FormLabel>
				)}
				<Input disabled={disabled} mask={mask} as={ReactInputMask} {...rest} />
				{errorMessage && <FormErrorMessage data-testid="text--error">{errorMessage}</FormErrorMessage>}
			</FormControl>
		</>
	);
};

export default InputMask;
